import DOMPurify from 'dompurify';
import { Faq } from 'src/api';
import './styles/faq.list.style.scss';

export interface IFAQListComponentProps {
    faqs: Array<Faq>;
}

export const FAQListComponent: React.FC<IFAQListComponentProps> = ({ faqs }) => {
    return (
        <div className='col-lg-7 col-sm-12'>
            <div className='d-flex p-2 item-title-container'> Item </div>
            <br />

            {faqs.map((item: Faq) => {
                return (
                    <div className='accordion accordion-background-active bg-white' style={{ fontSize: 16 }} id='accordion' key={item.ID}>
                        <div className='accordion-item'>
                            <h2 className='accordion-header' id='heading1c'>
                                <button
                                    className='accordion-button collapsed'
                                    style={{ margin: 0, fontWeight: 'normal', height: 52, fontSize: 16 }}
                                    type='button'
                                    data-bs-toggle='collapse'
                                    data-bs-target={`#acc${item.ID}`}
                                    aria-expanded='false'
                                    aria-controls={`acc${item.ID}`}>
                                    {item.post_title}
                                </button>
                            </h2>
                            <div id={`acc${item.ID}`} className='collapse' role='region' aria-labelledby='heading1c' key={item.ID}>
                                <div className='accordion-body' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.post_content as string) }}></div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
